import React, { useEffect, useRef, useState } from "react";

import { Link } from "react-router-dom";
import { dataListsType } from "../shared/type";
import LazyImage from "./lazyImage";

type Props = {
  props: dataListsType[];
};

const CardLeftRight: React.FC<Props> = ({ props }) => {
  const cardRefs = useRef<(HTMLAnchorElement | null)[]>([]);
  const [cardVisibleStates, setCardVisibleStates] = useState<boolean[]>(
    new Array(props.length).fill(false)
  );

  useEffect(() => {
    const observers: IntersectionObserver[] = [];
    cardRefs.current.forEach((ref, index) => {
      if (!ref) return;
      const observer = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) {
            setCardVisibleStates((prev) => {
              const newStates = [...prev];
              newStates[index] = true;
              return newStates;
            });
            observer.unobserve(ref);
          }
        },
        { threshold: 0.1 }
      );
      observer.observe(ref);
      observers.push(observer);
    });

    return () => {
      observers.forEach((observer) => observer.disconnect());
    };
  }, [props.length]);

  return (
    <>
      <div className="w-full h-full grid 2xl:grid-cols-2 grid-cols-1 gap-8 lg:gap-11">
        {props.map((item, key) => {
          const params = new URLSearchParams({
            id: String(item.id),
            category: item.category,
            slug: item.urlinform,
          });
          return (
            // <Link
            //   ref={(el) => {
            //     cardRefs.current[key] = el;
            //   }}
            //   rel="stylesheet"
            //   target="_top"
            //   to={{
            //     pathname: `/article`,
            //     search: params.toString(),
            //     // search: `?id=${item.id}&${item.category}/${item.urlinform}/`,
            //   }}
            //   key={key}
            // >
            <Link
              ref={(el) => {
                cardRefs.current[key] = el;
              }}
              to={`/article/${item.urlinform}`}
              target="_top"
              key={key}
            >
              <div
                className={`w-full 2xl:h-[280px] xl:h-[260px] lg:h-[250px] md:h-[230px] sm:h-[210px] h-[160px] flex justify-center items-center  md:p-3 p-2 bg-white/0 shadow-md transform transition-transform duration-500 ease-in-out hover:-translate-y-4 cursor-pointer fade-in-section ${
                  cardVisibleStates[key] ? "fade-in-visible" : ""
                }`}
                style={{
                  transitionDelay: `${key * 0.1}s`,
                }}
              >
                <div className="2xl:w-[60%] xl:w-[34%] lg:w-[32%] md:w-[36%] sm:w-[38%] w-[42%] h-full">
                  <LazyImage
                    src={item.images[0]}
                    alt={item.title}
                    className="w-full h-full object-cover"
                    loading="lazy"
                  />
                </div>

                <div className="w-[65%] h-full flex flex-col items-start pl-4 2xl:gap-4 md:gap-2 sm:gap-3">
                  {/* <div className="flex "> */}
                  <span className="lg:text-xl md:text-lg sm:text-base text-sm font-bold text-white my-1.5 py-1 px-3 rounded-sm bg-[#c9b077] leading-tight">
                    {item.category}
                  </span>
                  <span className="line-clamp-2">
                    <b className="2xl:text-3xl xl:text-3xl lg:text-3xl md:text-2xl sm:text-xl text-base font-bold]">
                      {item.title}
                    </b>
                    {/* <i className="text-opacity-0 bg-transparent text-[#c84e47] text-[6px]">
                      | Explore Asia
                    </i> */}
                  </span>

                  <span className="w-full md:mt-2 mt-0 2xl:text-lg xl:text-base md:text-base sm:text-sm text-xs font-medium text-[#555555] md:line-clamp-3 line-clamp-3 xl:line-clamp-3">
                    {item.description}
                  </span>
                  {/* </div> */}
                </div>
              </div>
            </Link>
          );
        })}
      </div>
    </>
  );
};

export default CardLeftRight;
